import getMarkdocModel from "../../getters/markdocModel";

export const c4Diagram = getMarkdocModel("C4-diagram");
